import { Typography } from "@suraasa/placebo-ui"
import { useEffect, useState } from "react"
import Lottie from "react-lottie"

export const AssessmentCompletedWithoutReport = () => {
  const [confettiAnimation, setConfettiAnimation] = useState<object | null>(
    null
  )

  useEffect(() => {
    import("assets/Cpat/cpat_confetti.json").then(mod =>
      setConfettiAnimation(mod.default)
    )
  }, [])

  return (
    <div className="relative mb-8 rounded-[16px] bg-[#0B5446]">
      {confettiAnimation && (
        // @ts-expect-error react version issues
        <Lottie
          style={{
            position: "absolute",
            width: "100%",
            margin: 0,
          }}
          isClickToPauseDisabled
          options={{
            loop: true,
            autoplay: true,
            animationData: confettiAnimation,
            rendererSettings: {
              preserveAspectRatio: "xMaxYMax slice",
            },
          }}
        />
      )}

      <div className="p-4">
        <Typography
          variant="smallBody"
          className="mb-2.5 text-[12px] text-white opacity-50"
        >
          ASSESSMENT
        </Typography>
        <div className="mb-2.5 flex flex-wrap gap-0.25">
          <Typography variant={"title2"} className="text-white">
            Good Job!{" "}
          </Typography>
          <Typography variant={"title2"} className="text-white opacity-60">
            You have successfully completed the Assessment.
          </Typography>
        </div>
      </div>
    </div>
  )
}
